(async function () {

	const bundle_raw_configuration = JSON.parse($('script#bundle-raw-configuration-json').html()) || {};
	const discount_tiers = {};
	const tier_descriptions = {};

	Object.keys(bundle_raw_configuration?.tiers || {}).forEach(tier => {
		const tierNum = parseInt(tier);
		discount_tiers[tierNum] = parseFloat(bundle_raw_configuration.tiers[tier].discount) || 0;
		tier_descriptions[tierNum] = bundle_raw_configuration.tiers[tier].description || '';
	});



	const freeGiftLimit = parseInt($('#free_gifts_allowed').val(), 10) || 0;
	const freeGiftsPreselected = $('#free_gifts_preselected').val() === 'true';

	function getSortedTiers(order = 'asc') {
		return Object.keys(discount_tiers).sort((a, b) => {
			return order === 'desc' ? parseInt(b) - parseInt(a) : parseInt(a) - parseInt(b);
		});
	}

	function getHighestTier() {
		const tiers = getSortedTiers('desc');
		return tiers.length ? parseInt(tiers[0]) : 0;
	}

	function getBundleItemRole($item) {
		return ($item.attr('data-bundle-item-role') || $item.data('bundle-item-role') || 'product').toString();
	}

	function isGiftItem($item) {
		return getBundleItemRole($item) === 'gift';
	}

	function getPaidProductCount() {
		return $('.bb-added-items-content .bb-item-active').filter(function () {
			return !isGiftItem($(this));
		}).length;
	}

	function getSelectedGiftCount() {
		return $('.bb-added-items-content .bb-item-active').filter(function () {
			return isGiftItem($(this));
		}).length;
	}

	function getCurrentTier($quantity) {
		$quantity = typeof $quantity === 'number' ? $quantity : getPaidProductCount();
		const tiers = getSortedTiers('desc');

		for (const tier of tiers) {
			if ($quantity >= parseInt(tier)) {
				return tier;
			}
		}

		return null;
	}

	function getItemText(count) {
		return count === 1 ? 'Item' : 'Items';
	}

	const strings = {
		'update_bundle_in_cart': 'UPDATE BUNDLE'
	};


	const bundle_key = new URL(window.location.href).searchParams.get('edit');
	let bundle_item;

	const bundle_metadata = {
		items: {}
	};

	if (bundle_key) {
		const cart_data = await (await fetch('/?view=cart_js')).json();
		bundle_item = cart_data.items.find(item => item.key === bundle_key);
	}


	// Hide/remove add button
	function showHideBundleActions(isEditMode = false){
		if(parseInt(document.getElementById('bundles_in_cart')?.value) >= (2 + (isEditMode ? 1 : 0))){
			document.querySelectorAll('.bundle-actions').forEach(node => {
				node.classList.add('hidden');
			})
		}else{
			document.querySelectorAll('.bundle-actions').forEach(node => {
				node.classList.remove('hidden');
			})
		}
	}

	showHideBundleActions(!!bundle_key);

	Shopify.formatMoney = function (cents, format) {
		if (typeof cents === 'string') {
			cents = cents.replace('.', '')
		}
		var value = '';
		var placeholderRegex = /{{\s*(\w+)\s*}}/;
		this.money_format = this.money_format || false;
		var formatString = format || this.money_format;
		var defaultOption = function (opt, def) {
			return (typeof opt === 'undefined' ? def : opt)
		};
		var formatWithDelimiters = function (number, precision, thousands, decimal) {
			precision = defaultOption(precision, 2);
			thousands = defaultOption(thousands, ',');
			decimal = defaultOption(decimal, '.');
			if (isNaN(number) || number == null) {
				return 0
			}
			number = (number / 100.0).toFixed(precision);
			var parts = number.split('.')
				, dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands)
				, cents = parts[1] ? (decimal + parts[1]) : '';
			return dollars + cents
		};
		switch (formatString.match(placeholderRegex)[1]) {
			case 'amount':
				value = formatWithDelimiters(cents, 2);
				break;
			case 'amount_no_decimals':
				value = formatWithDelimiters(cents, 0);
				break;
			case 'amount_with_comma_separator':
				value = formatWithDelimiters(cents, 2, '.', ',');
				break;
			case 'amount_no_decimals_with_comma_separator':
				value = formatWithDelimiters(cents, 0, '.', ',');
				break
		}
		return formatString.replace(placeholderRegex, value)
	};



	function priceUpdate() {

		const currentTier = getCurrentTier();
		let $price = 0;
		let $originalPrice = 0;

		$('.bb-added-items-content .bb-item-active').each(function () {
			const $id = $(this).data('variant-id');
			const $card = $('.card-wrapper[data-variant-id="' + $id + '"]');
			const $itemPrice = parseInt($(this).data('price'), 10) || parseInt($card.data('price'), 10) || 0;
			const $itemOriginalPrice = parseInt($(this).data('original-price'), 10) || parseInt($card.data('original-price'), 10) || $itemPrice;

			$originalPrice += $itemOriginalPrice;

			if (!isGiftItem($(this))) {
				$price += $itemPrice;
			}
		});

		const $priceChange = currentTier ? (1 - (discount_tiers[currentTier] / 100)) : 1;
		const $newPrice = $priceChange * $price;
		const $amountSaved = $originalPrice - $newPrice;

		const $originalPriceFormatted = Shopify.formatMoney($originalPrice, '${{amount}}');
		const $priceFormatted = Shopify.formatMoney($newPrice, '${{amount}}');
		const $savingsFormatted = Shopify.formatMoney($amountSaved, '${{amount}}');

		if ($originalPrice > $newPrice) {
			$('.bb-original-price').html($originalPriceFormatted).show();
		} else {
			$('.bb-original-price').hide();
		}
		if($amountSaved <= 0) {
			$('.bb-discount').addClass('visually-hidden');
		} else {
			$('.bb-discount').removeClass('visually-hidden');
		}
		$('.bb-current-discount').html((discount_tiers[currentTier] || 0) + '%');
		$('.bb-amount-saved').html('-' + $savingsFormatted);
		$('.bb-discounted-price').html($priceFormatted);
		$('.bb-discounted-price').data('price', $newPrice);

	}

	// To show the correct variant image when an item with variants is added
	setTimeout(function(){
		document.querySelectorAll('.card-variants-container').forEach(node => {
			if(node.querySelectorAll('input[data-variant-id]')?.length > 1){
				node.querySelector('input[data-variant-id]:checked')?.dispatchEvent(new Event('change', { bubbles: true }))
			}
		})
	}, 3000)
	

	function getStarted() {
		var $offset = $('.bb-collection-container').offset().top;
		$('html, body').animate({
			'scrollTop': $offset
		});
	}

	function buildPlaceholderHtml(slotNumber) {
		const slotKey = slotNumber.toString();
		const discount = discount_tiers[slotKey];
		const callActionClass = discount ? ' bb-item-call-action' : '';
		const discountHtml = discount ? '<span>' + discount + '% Off</span>' : '';

		return '<div class="bb-added-item bb-item-placeholder' + callActionClass + '"><div class="bb-added-item-image"><span class="bb-tier-key">' + slotNumber + '</span>' + discountHtml + '</div><p>Select Product</p></div>';
	}

	function escapeAttribute(value) {
		return $('<div>').text(value || '').html().replace(/"/g, '&quot;');
	}

	function isValidBundleImage(imageUrl) {
		return !!imageUrl && !/no[-_]image|placeholder|blank\.gif/i.test(imageUrl);
	}

	function buildAddedItemHtml($variantId, $variantName, $image, $type, $title, $role, $price, $originalPrice) {
		const cleanTitle = $('<div>').html($title || '').text();
		const imageHtml = $image ? '<img src="' + escapeAttribute($image) + '" alt="" />' : '';
		const removeHtml = $role === 'gift' && freeGiftsPreselected ? '' : '<a href="javascript:void(0)" class="remove-bb-item" aria-label="' + escapeAttribute('Remove ' + cleanTitle) + '"><svg xmlns="http://www.w3.org/2000/svg" width="9.02" height="9.02" viewBox="0 0 9.02 9.02"><g id="Group_2535" data-name="Group 2535" transform="translate(0.354 0.353)"><path id="Path_1691" data-name="Path 1691" d="M-3487.372-4476.921l-8.312-8.313" transform="translate(3495.685 4485.234)" fill="none" stroke="#fff" stroke-width="1"/><path id="Path_1692" data-name="Path 1692" d="M8.312,8.313,0,0" transform="translate(8.313 0) rotate(90)" fill="none" stroke="#fff" stroke-width="1"/></g></svg></a>';

		return '<div class="bb-added-item bb-item-active' + ($role === 'gift' ? ' bb-selected-gift-item' : '') + '" data-variant-id="' + $variantId + '" data-name="' + escapeAttribute($variantName) + '" data-image="' + escapeAttribute($image) + '" data-type="' + escapeAttribute($type) + '" data-bundle-item-role="' + $role + '" data-price="' + $price + '" data-original-price="' + $originalPrice + '">' + removeHtml + '<div class="bb-added-item-image">' + imageHtml + '</div><p class="bb-added-item-title">' + $title + '</p></div>';
	}

	function updateBundleUi() {
		const paidProductCount = getPaidProductCount();
		const selectedGiftCount = getSelectedGiftCount();
		const sortedTiers = getSortedTiers();
		const missingGiftCount = Math.max(freeGiftLimit - selectedGiftCount, 0);
		const hasRequiredGifts = selectedGiftCount === freeGiftLimit;
		let $nextTier = null;
		let $discount = '';

		$('#total_bundle_products').val(paidProductCount);
		$('.bb_products_in_bundle').html(paidProductCount + ' ' + (paidProductCount === 1 ? 'Product' : 'Products'));

		for (const tier of sortedTiers) {
			if (paidProductCount < parseInt(tier)) {
				$nextTier = tier;
				$discount = discount_tiers[tier] + '%';
				break;
			}
		}

		if (!$nextTier && sortedTiers.length) {
			$nextTier = sortedTiers[sortedTiers.length - 1];
			$discount = discount_tiers[$nextTier] + '%';
		}

		const $callActionCount = $nextTier ? parseInt($nextTier) - paidProductCount : 0;
		const $productText = getItemText($callActionCount);

		if ($callActionCount > 0) {
			$('.bb-progress-text').text(tier_descriptions[$nextTier] ? tier_descriptions[$nextTier] : 'Add ' + $callActionCount + ' more ' + $productText + ' to Get ' + $discount + ' off');
		} else if (!hasRequiredGifts) {
			$('.bb-progress-text').text('Add ' + missingGiftCount + ' free ' + (missingGiftCount === 1 ? 'gift' : 'gifts') + ' to complete your bundle');
		} else if (sortedTiers.length) {
			const highestTier = sortedTiers[sortedTiers.length - 1];
			$('.bb-progress-text').text('Congratulations! You get ' + discount_tiers[highestTier] + '% Off');
		}

		if (sortedTiers.length && paidProductCount >= parseInt(sortedTiers[0]) && hasRequiredGifts) {
			$('.bb-total-price-container').removeClass('visually-hidden');
			$('.bb-add-to-cart').addClass('bb-add-to-cart-active');

			if (bundle_key && bundle_item && Object.keys(bundle_item).length) {
				$('.bb-add-cart-text').text(strings.update_bundle_in_cart);
			} else {
				$('.bb-add-cart-text').text('Add to cart');
			}
		} else {
			$('.bb-total-price-container').addClass('visually-hidden');
			$('.bb-add-to-cart').removeClass('bb-add-to-cart-active');
			if ($callActionCount > 0) {
				$('.bb-add-cart-text').text('Add ' + $callActionCount + ' more ' + $productText);
			} else {
				$('.bb-add-cart-text').text('Add ' + missingGiftCount + ' free ' + (missingGiftCount === 1 ? 'gift' : 'gifts'));
			}
		}

		$('.bb-added-items-content .bb-item-placeholder').each(function (index) {
			const slotNumber = paidProductCount + index + 1;
			const slotKey = slotNumber.toString();
			const discount = discount_tiers[slotKey];
			$(this).toggleClass('bb-item-call-action', !!discount);
			$(this).find('.bb-tier-key').text(slotNumber);
			$(this).find('.bb-added-item-image > span:not(.bb-tier-key)').remove();
			if (discount) {
				$(this).find('.bb-added-item-image').append('<span>' + discount + '% Off</span>');
			}
		});

		priceUpdate();
		syncBundleCardStates();
	}

	function addNormalItem($this) {
		var $target = $this.closest('.bb-free-bag-item'),
			$variantId = $target.data('variant-id'),
			$variantName = $target.data('name'),
			$image = $target.data('image')	,
			$type = $target.data('type'),
			$title = $target.find('h3').html();
		const $role = getBundleItemRole($target);
		const isGift = $role === 'gift';
		const $price = parseInt($target.data('price'), 10) || 0;
		const $originalPrice = parseInt($target.data('original-price'), 10) || $price;
		const currentQuantityInBundle = getBundleItemQuantity($variantId);
		const maxAllowedQuantity = parseInt($target.data('max'), 10) || (isGift ? 1 : 2);

		if (isGift) {
			if (freeGiftLimit <= 0 || getSelectedGiftCount() >= freeGiftLimit || currentQuantityInBundle >= maxAllowedQuantity) {
				syncBundleCardStates();
				return;
			}
		} else if (getPaidProductCount() >= getHighestTier() || currentQuantityInBundle >= maxAllowedQuantity) {
			syncBundleCardStates();
			return;
		}

		const html = buildAddedItemHtml($variantId, $variantName, $image, $type, $title, $role, $price, $originalPrice);

		if (isGift) {
			$('.bb-added-items-content .bb-added-items-container').prepend(html);
		} else {
			const $placeholder = $('.bb-added-items-content .bb-added-item.bb-item-placeholder:first');

			if (!$placeholder.length) {
				syncBundleCardStates();
				return;
			}

			$placeholder.replaceWith(html);
		}

		saveToBundleMetadata($variantId, 1);
		updateBundleUi();
	}

	function saveToBundleMetadata(id, quantity = 1) {
		bundle_metadata.items[id] = bundle_metadata.items[id] || { quantity: 0 }
		bundle_metadata.items[id].quantity += quantity;

		if (bundle_metadata.items[id].quantity < 0) {
			bundle_metadata.items[id].quantity = 0;
		}

		syncBundleCardStates();
	}

	function syncBundleCardStates() {
		const paidProductCount = getPaidProductCount();
		const selectedGiftCount = getSelectedGiftCount();
		const maxPaidItems = getHighestTier();

		$('.card-wrapper.bb-free-bag-item').each(function () {
			const $card = $(this);
			const variantId = $card.data('variant-id');
			const role = getBundleItemRole($card);
			const isGift = role === 'gift';
			const quantity = bundle_metadata.items[variantId]?.quantity || 0;
			const maxQuantity = parseInt($card.data('max'), 10) || (isGift ? 1 : 2);
			const $button = $card.find('.bb-add-product-bundle');
			const isSoldOut = $button.hasClass('sold-out-variant') || $button.hasClass('bundle-item-disabled');
			let shouldDisable = isSoldOut;

			$card.toggleClass('bb-added-to-bundle', quantity > 0);
			$card.find('.bb-quantity input').val(quantity > 0 ? quantity : 1);

			if (quantity > 0 && quantity < maxQuantity && !isGift && paidProductCount < maxPaidItems) {
				$card.find('.quick-add').removeClass('bb-quantity-hidden');
			} else {
				$card.find('.quick-add').addClass('bb-quantity-hidden');
			}

			if (quantity >= maxQuantity) {
				$button.addClass('bb-item-remove-cart');
			} else {
				$button.removeClass('bb-item-remove-cart');
			}

			if (isGift) {
				if (quantity <= 0 && selectedGiftCount >= freeGiftLimit) {
					shouldDisable = true;
				}
			} else if (quantity < maxQuantity && paidProductCount >= maxPaidItems) {
				shouldDisable = true;
			}

			if (shouldDisable) {
				$button.addClass('disabled').attr('disabled', true);
			} else {
				$button.removeClass('disabled').removeAttr('disabled');
			}
		});
	}

	function initializePreselectedItems() {
		bundle_metadata.items = {};

		$('.bb-added-items-content .bb-item-active').each(function () {
			const variantId = $(this).data('variant-id');

			bundle_metadata.items[variantId] = bundle_metadata.items[variantId] || { quantity: 0 };
			bundle_metadata.items[variantId].quantity += 1;
		});

		updateBundleUi();
	}

	function clearSelectedBundleItems() {
		const $container = $('.bb-added-items-content .bb-added-items-container');
		const highestTier = getHighestTier();

		bundle_metadata.items = {};
		$container.empty();

		for (let slotNumber = 1; slotNumber <= highestTier; slotNumber++) {
			$container.append(buildPlaceholderHtml(slotNumber));
		}

		updateBundleUi();
	}

	function selectBundleComponent(variantId) {
		const variantIdString = String(variantId);
		const $variantInput = $('.single-item-holder input[data-variant-id]').filter(function () {
			return String($(this).data('variant-id')) === variantIdString;
		}).first();

		if ($variantInput.length) {
			$variantInput.prop('checked', true).trigger('change');
			$variantInput.closest('.single-item-holder').find('.bb-add-product-bundle').first().trigger('click');
			return true;
		}

		const $card = $('.single-item-holder .card-wrapper[data-variant-id]').filter(function () {
			return String($(this).data('variant-id')) === variantIdString;
		}).first();

		if ($card.length) {
			$card.find('.bb-add-product-bundle').first().trigger('click');
			return true;
		}

		return false;
	}

	function loadBundleItemComponents(item) {
		const itemComponents = item?.item_components || [];

		itemComponents.forEach(function (itemComponent) {
			const quantity = parseInt(itemComponent.quantity, 10) || 0;

			for (let i = 0; i < quantity; i++) {
				selectBundleComponent(itemComponent.id);
			}
		});

		updateBundleUi();
	}

	function getBundleItemQuantity(id) {
		bundle_metadata.items[id] = bundle_metadata.items[id] || { quantity: 0 }
		return bundle_metadata.items[id].quantity
	}

	if (bundle_key && bundle_item && Object.keys(bundle_item).length) {
		clearSelectedBundleItems();
		getStarted();
		setTimeout(function () {
			loadBundleItemComponents(bundle_item);
		}, 1);
	} else {
		initializePreselectedItems();
	}

	$(document).on('click', '.bb-add-product-bundle:not(.bb-item-remove-cart):not(.disabled):not(.sold-out-variant):not(.bundle-item-disabled)', function () {
		addNormalItem($(this))
	});

	$(document).on('click', '.bb-add-to-cart-active', function () {
		addToCart();
	});

	function resetBundle() {
		document.querySelector('.bb-added-items-content').innerHTML = document.querySelector('#bb-added-items-template').innerHTML;

		document.querySelectorAll('.bb-free-bag-item').forEach(elem => {
			elem.classList.remove('bb-added-to-bundle')
			elem.querySelector('.bb-add-product-bundle')?.classList.remove('disabled', 'bb-item-remove-cart');
			elem.querySelector('.bb-add-product-bundle')?.removeAttribute('disabled');
			if (elem.querySelector('.bb-quantity input')) {
				elem.querySelector('.bb-quantity input').value = 1;
			}
		});

		const current_url = new URL(window.location.href);
		current_url.searchParams.delete('edit');
		window.history.replaceState(null, '', current_url);
		bundle_item = null;


		Object.keys(bundle_metadata.items).forEach(itemId => {
			bundle_metadata.items[itemId].quantity = 0;
		});

		$('#total_bundle_products').val(0);
		$('.bb_products_in_bundle').html('0 Products');
		$('.bb-total-price-container').addClass('visually-hidden');
		initializePreselectedItems();
	}

	function addToCart() {
		const _timestamp = new Date().getTime();
		var $data = [];
		const productsInBundle = getPaidProductCount();
		const selectedGiftCount = getSelectedGiftCount();

		if (selectedGiftCount !== freeGiftLimit) {
			alert('Please select ' + freeGiftLimit + ' free ' + (freeGiftLimit === 1 ? 'gift' : 'gifts') + ' to complete your bundle.');
			return;
		}

		const parentProductJson = JSON.parse($('script#parent-product-json').html());

		$('.bb-added-items-content .bb-item-active').each(function () {
			var $this = $(this);
			const $variant = $this.data('variant-id');
			const $role = getBundleItemRole($this);
			const properties = {
				_bundle_product: 'Yes',
				_unique_bundle_id: _timestamp,
				_bundle_item_role: $role,
			};

			if ($role === 'gift') {
				properties._bundle_free_gift = 'Yes';
			}

			$data.push({
				'quantity': 1,
				'id': $variant,
				properties
			});
		});

		// Find the variant of parent product that suites for number of productsInBundle
		const parentVariant = parentProductJson.variants.find(variant => productsInBundle === parseInt(variant.title.split('-')[0]))
		if (!parentVariant) {
			alert('The selected bundle size is not available.');
			return;
		}
		$data.push({
			'quantity': 1,
			'id': parentVariant.id,
			properties: {
				_bundle_product: 'Yes',
				_unique_bundle_id: _timestamp,
				_bundle_free_gift_count: selectedGiftCount,
			}
		});

			const cart_holder = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
			const sections = cart_holder?.getSectionsToRender ? cart_holder.getSectionsToRender().map((section) => section.id) : [];
			const sectionsUrl = window.location.pathname + (window.location.search || '');
			const cartRequestData = {
				items: $data,
				sections_url: sectionsUrl
			};

			if (sections.length) {
				cartRequestData.sections = sections;
			}

			if (cart_holder?.setActiveElement) {
				cart_holder.setActiveElement(document.getElementById('CartDrawer'));
			}

			function renderCartContents(response) {
				if (!cart_holder?.renderContents) {
					window.location.href = (window.Shopify?.routes?.root || '/') + 'cart';
					return;
				}

				if (cart_holder.classList.contains('is-empty')) {
					cart_holder.classList.remove('is-empty');
				}

				cart_holder.renderContents(response);
			}

			$.ajax({
				type: 'POST',
				url: '/cart/add.js',
				dataType: 'json',
				data: cartRequestData,
				success: function (response) {
					if (response.status) {
						alert(response.description || 'An error has occurred.')
						return;
					}

					if (bundle_key && bundle_item && Object.keys(bundle_item).length) {
						let updates = {};
						const updateBody = {
							updates,
							sections_url: sectionsUrl
						};
						updates[bundle_key] = 0;

						if (sections.length) {
							updateBody.sections = sections;
						}

						fetch(window.Shopify.routes.root + 'cart/update.js', {
							method: 'POST',
							headers: {
								'Content-Type': 'application/json'
							},
							body: JSON.stringify(updateBody)
						}).then(response => {
							return response.json();
						}).then(response => {
							renderCartContents(response);
							showHideBundleActions();
						})
							.catch(() => {
								alert('An error occurred while updating your bundle.');
							});
					} else {
						renderCartContents(response);
					}
				},
			error: function (response, a, b) {
				if (response) {
					alert(response?.responseJSON?.description || 'An error has occurred.')
					return;
				}
			},
			complete: function (data) {
				resetBundle();
			}
		});
	}

	$(document).on('click', '.remove-bb-item', function () {
		var $this = $(this),
			$target = $this.closest('.bb-item-active'),
			$variantId = $target.data('variant-id');
		const wasGift = isGiftItem($target);

		if (!wasGift) {
			const slotNumber = getPaidProductCount();
			const placeholderHtml = buildPlaceholderHtml(slotNumber);
			const $insertPoint = $('.bb-added-items-content .bb-added-item.bb-item-placeholder:first');

			if ($insertPoint.length) {
				$insertPoint.before(placeholderHtml);
			} else {
				$('.bb-added-items-content .bb-added-items-container').append(placeholderHtml);
			}
		}

		$target.remove();
		saveToBundleMetadata($variantId, -1);
		updateBundleUi();
	});

	$(document).on('click', '.bb-quantity .bb-quantity-minus', function () {
		var $this = $(this),
			$quantityInput = $this.closest('.bb-quantity').find('input'),
			$min = $quantityInput.attr('min'),
			$quantity = $quantityInput.val();
		var $variantId = $this.closest('.bb-free-bag-item').attr('data-variant-id');
		$('.bb-added-item[data-variant-id="' + $variantId + '"]').each(function (index) {
			var $this = $(this);
			if (index == 0) {
				$this.find('.remove-bb-item').trigger('click');
			}
		});
	});

	$(document).on('click', '.bb-quantity .bb-quantity-plus', function () {
		var $this = $(this),
			$quantityInput = $this.closest('.bb-quantity').find('input'),
			$max = parseInt($quantityInput.attr('max')),
			$quantity = parseInt($quantityInput.val());
		if ($quantity < $max && getBundleItemQuantity(parseInt($this.closest('[data-variant-id]').data('variant-id'))) < $max) {
			$quantity = parseInt($quantity) + 1;
			$quantityInput.val($quantity).trigger('change');
			$this.closest('.bb-free-bag-item').find('.bb-add-product-bundle').trigger('click');
		}
	});


	$(document).on('change input', '.card-variants-container input', function() {
			var $this = $(this),
				image = $this.data('image'),
				id = $this.data('variant-id'),
				price = $this.data('price'),
				formattedPrice = $this.data('price-formatted'),
					formattedCompare = $this.data('compare-price-formatted'),
					comparePrice = parseInt($this.data('compare-price'), 10) || 0,
				available = $this.data('available'),
				$cardWrapper = $this.closest('.card-wrapper'),
				button = $cardWrapper.find('.bb-add-product-bundle'),
				isGift = getBundleItemRole($cardWrapper) === 'gift',
				productName = $cardWrapper.find('.bb-product-details').data('product-name') || $cardWrapper.find('.card__heading').text().trim(),
				variantName = $this.val(),
				itemName = variantName && variantName !== 'Default Title' ? productName + ' - ' + variantName : productName;
			if (!isValidBundleImage(image)) {
				image = $cardWrapper.data('image');
			}

			if (available) {
				button.removeClass('sold-out-variant bundle-item-disabled');
			} else {
				button.addClass('sold-out-variant bundle-item-disabled');
			}
			const cardData = { 'variant-id': id, name: itemName, price: isGift ? 0 : price, 'original-price': price };

			if (isValidBundleImage(image)) {
				cardData.image = image;
			}

			$cardWrapper
				.attr('data-variant-id', id)
				.attr('data-name', itemName)
				.attr('data-original-price', price)
				.attr('data-price', isGift ? 0 : price)
				.data(cardData);
			if (isValidBundleImage(image)) {
				$cardWrapper
					.attr('data-image', image)
					.data('image', image);
				$cardWrapper.find('.card__media img')
					.attr('src', image)
					.attr('data-src', image)
					.removeAttr('srcset')
					.removeAttr('data-srcset');
			}
			var $priceEl = $cardWrapper.find('.price');

			if (isGift) {
				$priceEl.find('.price__regular .price-item--regular').html('Free');
				$priceEl.find('.price__sale .price-item--sale').html('Free');
				$priceEl.find('.price__sale s.price-item--regular').html(formattedPrice);
			} else {
				$priceEl.find('.price__regular .price-item--regular').html(formattedPrice);
				$priceEl.find('.price__sale .price-item--sale').html(formattedPrice);
				if (comparePrice && comparePrice > price) {
					$priceEl.find('.price__sale s.price-item--regular').html(formattedCompare);
					$priceEl.addClass('price--on-sale').removeClass('price--no-compare');
				} else {
					$priceEl.removeClass('price--on-sale');
				}
			}
			if (!available) {
				$priceEl.addClass('price--sold-out');
			} else {
				$priceEl.removeClass('price--sold-out');
			}
			syncBundleCardStates();
			priceUpdate();
		});
})()

$(document).on('click', 'a[data-section]', function(){
	var $this = $(this),
	$offset = $($this.data('section')).offset().top;
	$('html, body').animate({
		'scrollTop':$offset
	})
});

$(document).on('click', '.bb_expand_progress', function(){
	$(this).closest('.bb-progress').toggleClass('bb-view-expanded');
});

$(document).on('scroll', function(){
	if($(window).scrollTop() > 50) {
		$('.bb-progress').addClass('bb-progress-visible');
	} else {
		$('.bb-progress').removeClass('bb-progress-visible');
	}
});

$(document).on('click', '.bb-product-details', function () {
	var $this = $(this),
		$url = '/products/' + $this.attr('href'),
		$type = $this.data('type'),
		$weight = $this.data('weight'),
		$desc = $this.data('desc'),
		$variantid = $this.closest('.card-wrapper').data('variant-id'),
		$variantPrice = $this.closest('.card-wrapper').data('price'),
		$isGift = $this.closest('.card-wrapper').attr('data-bundle-item-role') === 'gift',
		$variantImage = $this.closest('.card-wrapper').data('image'),
		$productImage = $this.closest('.card-wrapper').data('product-image'),
		$productName = $this.closest('.card-wrapper').data('product-name');
	$('.bb-mobile-content img').attr('src', '');
	$('.bb-mobile-content img + img').attr('src', '');
	$('.bb-mobile-content .rte').html('');
	$('.bb-product-type .rte').html('');
	$('.bb-mobile-content .bb-add-bundle-trigger').attr('data-variant-id', '');
	$('.bb-product-title').html('');
	$('.bb-price').html('');
	$.ajax({
		type: 'GET',
		url: $url,
		dataType: 'json',
		success: function (data) {
			var product = data.product,
				$image = $variantImage || product.image.src,
				$variant_id = $variantid || product.variants[0].id,
				$price = $variantPrice || '$'+product.variants[0].price,
				$title = $productName || product.title;
			$('.bb-product-title').html($title);
			$('.bb-mobile-content img').attr('src', $image);
			$('.bb-product-type').html($type);
			$('.bb-mobile-content .rte').html($desc);
			$('.bb-mobile-content .bb-add-bundle-trigger').attr('data-variant-id', $variant_id);
			if($this.closest('.card-wrapper').find('.content-for-info-popup').length) {
				$('.bb-product-benefits').show();
				$('.bb-product-benefits').html($this.closest('.card-wrapper').find('.content-for-info-popup').html());
			} else {
				$('.bb-product-benefits').hide();
			}
			if ($weight == '' | $weight == ' ') {
				$('.bb-price').html('<strong>' + ($isGift ? 'Free' : Shopify.formatMoney($price, '${{amount}}')) + '</strong>');
			} else {
				$('.bb-price').html('<strong>' + ($isGift ? 'Free' : Shopify.formatMoney($price, '${{amount}}')) + '</strong> | ' + $weight);
			}
		}
	});
	return false;
});
